import React, { useMemo } from 'react';
import { Input } from 'glintly-ui';
import { DEFAULT_SERVICE_TAGS } from '../../../constants/serviceTags';
import styles from './services.module.css';

export default function ServiceTagsField({ formData, setFormData, suggestionData }) {
  const suggestionsList = useMemo(() => {
    const defaultTags = suggestionData?.defaultTags ?? DEFAULT_SERVICE_TAGS;
    const customTags = suggestionData?.customTags ?? [];
    const seen = new Set();
    const out = [];
    for (const t of [...defaultTags, ...customTags]) {
      if (!t || seen.has(t)) continue;
      seen.add(t);
      out.push(t);
    }
    return out;
  }, [suggestionData?.defaultTags, suggestionData?.customTags]);

  const toggleChip = (tag) => {
    setFormData((prev) => {
      const tags = prev.tags || [];
      const has = tags.includes(tag);
      return {
        ...prev,
        tags: has ? tags.filter((t) => t !== tag) : [...tags, tag],
      };
    });
  };

  const extraValue = useMemo(() => {
    const sug = new Set(suggestionsList);
    return (formData.tags || []).filter((t) => !sug.has(t)).join(', ');
  }, [formData.tags, suggestionsList]);

  const onExtraChange = (value) => {
    const extra = value
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean);
    setFormData((prev) => {
      const sug = new Set(suggestionsList);
      const fromChips = (prev.tags || []).filter((t) => sug.has(t));
      const merged = [...new Set([...fromChips, ...extra])];
      return { ...prev, tags: merged };
    });
  };

  return (
    <div className={styles.tagField}>
      <p className={styles.tagFieldTitle}>Our Services — tags</p>
      <p className={styles.tagFieldHint}>
        Tap to select. Type extra tags below; they appear here on your next service.
      </p>
      <div className={styles.tagChipRow} role="group" aria-label="Service tags">
        {suggestionsList.map((tag) => {
          const active = (formData.tags || []).includes(tag);
          return (
            <button
              key={tag}
              type="button"
              className={`${styles.tagChip} ${active ? styles.tagChipActive : ''}`}
              onClick={() => toggleChip(tag)}
            >
              {tag}
            </button>
          );
        })}
      </div>
      <Input.Root name="tags-extra">
        <Input.Label>Additional tags (comma separated)</Input.Label>
        <Input.Control
          value={extraValue}
          onChange={(e) => onExtraChange(e.target.value)}
          placeholder="Add tags not in the list above"
        />
      </Input.Root>
    </div>
  );
}
